import { PaginatedApiArg, PaginatedApiResponse } from 'lib-shared-types-api';
import { useEffectOnce } from 'react-use';

import {
  useLazyPaginatedEndpoint,
  UsePaginatedResult,
} from '../useLazyPaginatedEndpoint';

import { UsePaginatedOptions } from './usePaginatedEndpoint.types';

/**
 * Represents a hook that simplifies working with paginated endpoints. It
 * encapsulates the items, while exposing functions for navigating the pages,
 * changing the arg, re-fetching, updating an item, and more.
 */
export const usePaginatedEndpoint = <
  TPaginatedApiArg extends PaginatedApiArg,
  TPaginatedApiResponse extends PaginatedApiResponse,
  TItem,
>({
  initialArg,
  ...options
}: UsePaginatedOptions<
  TPaginatedApiArg,
  TPaginatedApiResponse,
  TItem
>): UsePaginatedResult<TItem, TPaginatedApiArg> => {
  const result = useLazyPaginatedEndpoint<
    TPaginatedApiArg,
    TPaginatedApiResponse,
    TItem
  >(options);

  useEffectOnce(() => {
    result.changeArg(initialArg);
  });

  return result;
};
